export { CollapsibleSidePanel } from './src/collapsible-side-panel';
